var GLOBALS = {
	name : "",
	img : "",
	finalImage : "",
	brightness_slider_url : "media/img/slider/brightness_slider.jpg",
	contrast_slider_url : "media/img/slider/contrast_slider.jpg",
	scale_slider_url : "media/img/slider/scale_slider.jpg",
	twitterImg :""
};
